export const Z_INDEX = {
  ALERT_TOAST: 1000,
  DROPDOWN: 51,
  MODAL: 40,
  POPOVER: 30,
  TOOLTIP: 6,
  HEADER: 10,
  SIDEBAR: 2,
};
